













import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';

type Tab = [{ tab: string }, { tab: string }]

@Component

export default class Tabs extends Vue {
    @Inject() eventBus!: Vue;
    selectedTab = '支出';
    tabs: Tab = [{ tab: '支出' }, { tab: '收入' }];

    //初始
    mounted() {
        this.eventBus.$emit('updateSelectedTab', this.selectedTab);
    }

    //实时更新
    changeSelectedTab(tab: string) {
        this.selectedTab = tab;
        this.eventBus.$emit('updateSelectedTab', this.selectedTab);
        this.$emit('selectedTab',this.selectedTab)
    }
}
